import { render, staticRenderFns } from "./ScrollToTop.vue?vue&type=template&id=361a6926&scoped=true&"
import script from "./ScrollToTop.vue?vue&type=script&lang=js&"
export * from "./ScrollToTop.vue?vue&type=script&lang=js&"
import style0 from "./ScrollToTop.vue?vue&type=style&index=0&id=361a6926&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../bdap-area-delete-20261102/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361a6926",
  null
  
)

export default component.exports